import { getBoards, apiResultSuccess, getBoardSettings, getBoardTypes } from '../apihelper';
import BoardsController from '../controllers/BoardsController';
import BoardSettingsController from '../controllers/BoardSettingsController';

class DataManager {

    constructor() {
        if ( !DataManager.instance ) {
            this.boards = [];
            this.boardsController = new BoardsController([]);
            this.boardObjects = [];
            this.settings = {
                boards: [],
                boardTypes: [],
                list: [ 
                    {id: 1, 'type': 'Boards', title: 'Boards', icon: 'boards', contents: [], controller: false},
                    {id: 0, 'type': 'General', title: 'General', icon: 'settings', contents: []},
                ]
            };

            this.boardTypes = [];
        }
    }

    fetchData() {
        this.fetchBoardsData();
        this.fetchSettingsData();
    }

    // Boards

    fetchBoardsData() {
        this.boardsController.fetchBoardsData((data) => {
            this.handleFetchedBoards(data);
        });
    }

    getBoardsData() {
        return this.boards;
    }

    handleFetchedBoards(fetchedBoards=[]) {
        this.boards = fetchedBoards;
        this.boardsController.createObserver();
    }


    boardUpdate(board, updateType) {

    }

    // Settings

    fetchSettingsData() {
        getBoardTypes(
            (results) => {
                if ( apiResultSuccess(results) ) {
                    if ( results.types ) {
                        this.boardTypes = results.types;
                        this.settings.boardTypes = results.types;
                    }
                }
            }
        );

        getBoardSettings(
            (results) => {
                if ( apiResultSuccess(results) ) {
                    if ( results.boards ) {
                        this.processBoardsData(results.boards);
                        this.settings.boards = results.boards;
                    }
                }
            }
        );
    }

    processBoardsData(boards=[]) {
        if ( this.settings.list.length > 0 ) {
            const boardsIndex = this.settings.list.map( (e) => {  return e.type; } ).indexOf('Boards');

            if ( boardsIndex !== -1 ) {
                
                this.settings.list[boardsIndex].contents = boards;

                const boardsData = this.settings.list[boardsIndex];                
                const controller = new BoardSettingsController(boardsData, [], boardsData.boards, this.settings.boardTypes);

                // Marry BoardSettings with BoardsController
                controller.addObserver( this.boardsController.getObserver() );

                this.settings.list[boardsIndex].controller = controller;

            }
        }
    }

    handleFetchedSettingsData(settingsData) {
        this.settingsList = settingsData;
    }

    getSettingsData() {
        return this.settings;
    }
}

const dataManager = new DataManager();
export default dataManager;